export default __webpack_public_path__ + "static/media/97t.49fda17a.jpg";